module.exports = __webpack_public_path__ + "img/teploenergetic.ec908f5e.png";